import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { CookieConsentProps } from './cookieConsent.props'

const schema = {
  basic: {
    url: FieldTypeFactory.text(),
    label: FieldTypeFactory.text(),
    configure: FieldTypeFactory.text(),
    description: FieldTypeFactory.text(),
    agree: FieldTypeFactory.text(),
  },
  advanced: {
    moreInfo: FieldTypeFactory.text(),
    acceptAll: FieldTypeFactory.text(),
    saveChanges: FieldTypeFactory.text(),
  },
  details: {
    table: {
      source: FieldTypeFactory.text(),
      name: FieldTypeFactory.text(),
      purpose: FieldTypeFactory.text(),
      maxAge: FieldTypeFactory.text(),
    },
    goBack: FieldTypeFactory.text(),
  },

  // disagree: FieldTypeFactory.text({ required: false }),
  isEnabled: FieldTypeFactory.boolean({ defaultValue: true }),
}

const CookieConsentType = ComponentTypeFactory.create<CookieConsentProps>(
  'CookieConsent',
  schema
)

export { CookieConsentType }
